export class ContactAddress {
  contactId: number;
  companyId: number;
  steetrName: string;
  streetName2: string;
  streetName3: string;
  cityName: string;
  stateProvinceName: string;
  zipCode: string;
  countryName: string;
  countryCode: string;
  priorityLevelRank: number;
  addressType: number;
  isExpired: boolean;
}
